/*
  *@Description: 语音服务
*/
import React, { useState, useEffect, useRef } from 'react'
import { IonPage } from '@ionic/react'
import { wxConfigG } from 'controllers/third'
import Recorder from 'controllers/record'

import { posServiceMobx, voiceServiceMobx } from '@mobxStore'
import { menuMobx } from 'restaurant'

import { SearchModal } from '../menu/modal'
import CashierController from 'controllers/cashierController'
import { modalLayer, getPlatform } from '@utils'
import VOICEDEFAULTGIF from '@img/voice_default.gif'
import VOICEGIF from '@img/voice.gif'

import './index.scss'

interface IContentItem {
  content: string;
  content_id: string;
  content_type: string;
  score: number;
}
interface IProps {

}

const VoiceService: React.FC<IProps> = props => {
  const { } = props
  const { codeType } = Config
  const [isRecording, setIsRecording] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [isCallService, setIsCallService] = useState<boolean>(false)
  const [isErr, setIsErr] = useState<boolean>(false)
  const [localId, setLocalId] = useState<string>()
  const timer = useRef(null)
  const recorder = useRef(null)

  let voiceDuration = 8
  const voiceDurationInter = useRef(null)

  const { sendServiceRing, serviceRingDuration } = posServiceMobx

  const { isWeixinMiniProgram, isAndroid } = getPlatform()

  // let recorder.current = null

  useEffect(() => {
    // if (!wxConfigG.isInited()) {
    //   Recorder.get((rec) => {
    //     recorder.current = rec
    //   })
    // }
    // 解决安卓微信小程序请求js-sdk报签名无效的错误问题
    if (isAndroid && isWeixinMiniProgram) {
      wxConfigG.init()
    }

    if (wxConfigG.isInited()) {
      wx.startRecord({
        success: function (res) {
          wx.stopRecord({
            success: (res) => {}
          })
        },
        fail: function (err) {
          console.log(err, 'err')
        }
      })
    } else {
      Recorder.get((rec) => {})
    }
  }, [])

  const startCountDown = () => {
    voiceDuration = 8
    voiceDurationInter.current = setInterval(() => {
      if (voiceDuration === 0) {
        clearInterval(voiceDurationInter.current)
        stopRecord()
        return
      }
      voiceDuration--
    }, 1000)
  }

  const handleTouchStart = (e) => {
    if (loading) {
      return false
    }
    e.preventDefault()
    if (wxConfigG.isInited()) {
      wx.startRecord({
        success: function (res) {
          setIsRecording(true)
          const tempFilePath = res.tempFilePath
          startCountDown()
        },
        fail: function (err) {
          console.log(err, 'err')
        }
      })
    } else {
      Recorder.get((rec) => {
        recorder.current = rec
        setIsRecording(true)
        rec.start().then(res => {
          startCountDown()
        })
      })
    }
    timer.current = setTimeout(function () {
      e.preventDefault()
      // LongPress(parentObj);
      return false
    }, 800)
  }

  const handleTouchMove = () => {
    clearTimeout(timer.current)
    timer.current = 0
  }

  const handleVoiceCall = (content?: string, list?: IContentItem[]) => {
    if (!content || !content.length) {
      setLoading(false)
      setIsErr(true)
      return
    }
    setIsErr(false)
    setLocalId('')
    // if (codeType === 'table' && content.toLocaleLowerCase().includes(i18n.t('voice.servicer').toLocaleLowerCase())) {
    if (codeType === 'table' && list.filter(item => item.content_type === 'call_waiter').length) {
      sendServiceRing(content).then(res => {
        setLoading(false)
        setIsCallService(true)
        // if (res) {}
      }).catch((err) => {
        console.log(err, 'err')
        setLoading(false)
        setIsErr(true)
        setIsCallService(false)
      })
    } else {
      menuMobx.setSearchKey(content)
      setIsCallService(false)
      setLoading(false)
      modalLayer(SearchModal, {
      }).then((product: any) => {
        CashierController.showProductDetail(product)
        menuMobx.setSearchKey('')
      }).catch(() => {
        menuMobx.setSearchKey('')
      })
    }
  }

  const stopRecord = () => {
    if (wxConfigG.isInited()) {
      isRecording && wx.stopRecord({
        success: (res) => {
          const localId = res.localId
          setLocalId(localId)
          // 如果是主动停的，则直接进行微信识别
          if (voiceDuration !== 0) {
            handleWxTranslate(localId)
          }
        }
      })
    } else {
      recorder.current?.stop()
    }
  }

  const handleTouchEnd = () => {
    clearTimeout(timer.current)
    timer.current = null
    clearInterval(voiceDurationInter.current)
    voiceDurationInter.current = null

    // 如果是主动停的，则松开按钮时要调用停止方法
    if (voiceDuration !== 0) {
      stopRecord()
    }
    setIsRecording(false)

    if (wxConfigG.isInited()) {
      if (voiceDuration === 0) {
        if (localId) {
          handleWxTranslate(localId)
        } else {
          setIsErr(true)
        }
      }
    } else {
      if (recorder.current) {
        const blob = recorder.current.getBuffer()
        let formData = new FormData()
        formData.append('f', blob)
        // let audio = document.getElementById('audio') as any
        // recorder.current.play(audio)
        setLoading(true)
        voiceServiceMobx.voiceMatch(formData).then(res => {
          const { content, info } = res
          handleVoiceCall(info.full_content, content)
        }).catch(err => {
          setLoading(false)
          setIsErr(true)
          console.log(err, 'err')
        })
      }
    }
    // timer.current = 0
    return false
  }

  const handleWxTranslate = (localId) => {
    setLoading(true)
    wx.translateVoice({
      localId, // 需要识别的音频的本地Id，由录音相关接口获得
      isShowProgressTips: 0, // 默认为1，显示进度提示
      success: function (res) {
        console.log(res.translateResult) // 语音识别的结果
        voiceServiceMobx.contentMatch(res.translateResult).then(res => {
          const { content, info } = res
          handleVoiceCall(info.full_content, content)
        }).catch(err => {
          console.log(err, 'err')
          setLoading(false)
          setIsErr(true)
        })
        // handleVoiceCall()
      }
    })
  }

  return (
    <IonPage className='voice-page'>
      <div className='btn-back' onClick={() => history.back()}>
        <i className='iconfont icon-BACK-12x'></i>
      </div>
      <div className='sign'>
        {
          !isRecording && !isErr && !loading && !isCallService && <img src={VOICEDEFAULTGIF} alt='' className='default' />
        }
        {
          isRecording && <img src={VOICEGIF} alt='' />
        }
        {
          !isRecording && (
            loading ? (
              <div className='result'>
                <i className='iconfont icon-voice_loading'></i>
                {/* <p>{i18n.t('voice.parsing')}</p> */}
              </div>
            ) : (
              isErr ? (
                <div className='result'>
                  <i className='iconfont icon-vioce_ear'></i>
                  <p>{i18n.t('voice.parsingfail')}</p>
                  <p>{i18n.t('voice.sayagain')}</p>
                </div>
              ) : (
                isCallService && (
                  <div className='result'>
                    <i className='iconfont icon-voice_complete'></i>
                    <p>{i18n.t('voice.hasCallService')}</p>
                    <p>{i18n.t('voice.waitamonment')}</p>
                  </div>
                )
              )
            )
          )
        }
      </div>
      <div className='content'>
        {
          !isRecording && !isErr && !loading && !isCallService ? (
            <div className='tips'>
              <div className='tip1'>
                <p>{i18n.t('voice.serviceHelpCanSay1')}</p>
                <p>
                  {
                    codeType === 'table' ? i18n.t('voice.serviceHelp') : i18n.t('voice.productName')
                  }
                </p>
              </div>
              {
                codeType === 'table' && (
                  <div className='tip2'>
                    <p>or</p>
                    <p>{i18n.t('voice.productName1')}</p>
                  </div>
                )
              }
            </div>
          ) : <></>
        }
        <div className={`btn ${loading ? 'parsing' : ''} ${isRecording ? 'recording' : ''}`} onMouseDown={handleTouchStart} onMouseUp={handleTouchEnd} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
          <i className={`iconfont ${isRecording ? 'icon-voice_speak' : 'icon-vioce_microphone'}`}></i>
          <p>{i18n.t(`voice.${isRecording ? 'talking' : 'pressAndHoldToTalk'}`)}</p>
        </div>
        {/* <audio src='' className='audio-node' id='audio' controls /> */}
      </div>
    </IonPage>
  )
}

export default VoiceService
